import React from 'react';
import clsx from 'clsx';
import { SfdrCategoryId, Fund } from 'funds-model';
import { Tooltip } from '../Tooltip/Tooltip';
import { Typography } from '../Typography/Typography';
import { useTranslation } from "react-i18next";
import { ReactComponent as LeafIcon } from '../../../common-assets/assets/icons/leaf.svg';
import { ReactComponent as LeafsIcon } from '../../../common-assets/assets/icons/leafs.svg';

import useStyles from './SfdrCategoryFundItem.style';

export const renderLeafIcons = (sfdrCategoryId?: SfdrCategoryId, className?: string) => {
  switch (sfdrCategoryId) {
    case SfdrCategoryId.ART_8: {
      return <LeafIcon data-testid="art-8" className={className} />;
    }
    case SfdrCategoryId.ART_9: {
      return <LeafsIcon data-testid="art-9" className={className} />;
    }
    case SfdrCategoryId.NO_ESG: {
      return null;
    }
    default: {
      return null;
    }
  }
}

export const SfdrCategoryFundItem: React.FC<{ fund: Fund, className?: string }> = ({ fund, className }) => {
  const c = useStyles({});
  const [t] = useTranslation("components");

  const renderLeafTooltip = () => (
    <Tooltip
      data-testid="tooltip"
      arrow
      title={
        <span>
          {fund.sfdrCategoryId === SfdrCategoryId.ART_8
            ? t('fund-list.sfdr-category-8')
            : t('fund-list.sfdr-category-9')}
        </span>
      }
      customIcon={renderLeafIcons(fund.sfdrCategoryId) || <></>}
    />
  );

  return (
    <li className={clsx(className, c.root)} key={fund.id}>
      {(fund.sfdrCategoryId === SfdrCategoryId.ART_8 || fund.sfdrCategoryId === SfdrCategoryId.ART_9) && renderLeafTooltip()}
      <Typography fontWeight='bold'>{fund.name}</Typography>
    </li>
  );
}
